module.exports = __webpack_public_path__ + "img/11.91c672a0.png";